import React from 'react';
import { connect } from 'dva';

import styles from './UserLayout.less';
import logo from '../assets/background.png';

const UserLayout = ({ children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.bg}>
        <img src={logo} alt="ARS Background and Logo" />
      </div>
      <div style={{ flex: 1 }}>{children}</div>
    </div>
  );
}

export default connect(({ menu: menuModel }) => ({
  menuData: menuModel.menuData,
}))(UserLayout);
